module.exports = __webpack_public_path__ + "static/img/search-backround.9f0bfb80.png";